import { useDispatch } from 'react-redux';

import { AppDispatch } from './state.types';

export default useDispatch<AppDispatch>;
